'use client'

import * as TabsPrimitive from '@radix-ui/react-tabs'
import { VariantProps } from 'cva'
import * as React from 'react'

import { cn } from '../../lib/util'

import { tabListV1Style, tabsTriggerV1Style } from './tabs.css'

/**
 * @deprecated Use Tabs instead
 */
const TabsV1 = (props: React.ComponentProps<typeof TabsPrimitive.Root>) => <TabsPrimitive.Root {...props} />

const TabsV1List = ({
  className,
  variants = 'flexible',
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List> & VariantProps<typeof tabListV1Style>) => {
  return <TabsPrimitive.List className={cn(tabListV1Style({ variants }), className)} {...props} />
}

const TabsV1Trigger = ({
  className,
  variants = 'flexible',
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger> & VariantProps<typeof tabsTriggerV1Style>) => {
  return <TabsPrimitive.Trigger className={cn(tabsTriggerV1Style({ variants }), className)} {...props} />
}

const TabsV1Content = ({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) => (
  <TabsPrimitive.Content
    className={cn(
      [
        'ring-offset-background',
        'focus-visible:outline-none',
        'focus-visible:ring-2',
        'focus-visible:ring-ring',
        'focus-visible:ring-offset-2',
      ],
      className,
    )}
    {...props}
  />
)

TabsV1List.displayName = TabsPrimitive.List.displayName
TabsV1Trigger.displayName = TabsPrimitive.Trigger.displayName
TabsV1Content.displayName = TabsPrimitive.Content.displayName

export { TabsV1, TabsV1Content, TabsV1List, TabsV1Trigger }
